import { render, staticRenderFns } from "./myNeofintechEcobankaTV.vue?vue&type=template&id=4e5413c4&scoped=true&"
import script from "./myNeofintechEcobankaTV.vue?vue&type=script&lang=js&"
export * from "./myNeofintechEcobankaTV.vue?vue&type=script&lang=js&"
import style0 from "./myNeofintechEcobankaTV.vue?vue&type=style&index=0&id=4e5413c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5413c4",
  null
  
)

export default component.exports